import { takeEvery,takeLatest, put, call } from "redux-saga/effects";
import {
  FETCH_LOGIN_DETAILS,
  FETCH_UNREGISTERED_EMPLOYEES,
  CREATE_LOGIN_USER_REQUEST,
  CREATE_LOGIN_USER_SUCCESS,
  CREATE_LOGIN_USER_FAILURE,
  RESET_PASSWORD_REQUEST, 
  TOGGLE_USER_STATUS_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  FETCH_ACCESS_RIGHTS_REQUEST,
  FETCH_ROLES_REQUEST,
  FETCH_ACCESS_RIGHTS_SUCCESS,
  FETCH_ACCESS_RIGHTS_FAILURE,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  SAVE_ROLE_ACCESS_RIGHTS_REQUEST,
  SAVE_ROLE_ACCESS_RIGHTS_SUCCESS,
  SAVE_ROLE_ACCESS_RIGHTS_FAILURE,
  FETCH_MODULES_SUCCESS,
  FETCH_MODULES_FAILURE,
  FETCH_MODULES_REQUEST,
  SAVE_MODULE_SUCCESS,
  SAVE_MODULE_FAILURE,
  SAVE_MODULE_REQUEST,
  DELETE_MODULE_SUCCESS,
  DELETE_MODULE_FAILURE,
  DELETE_MODULE_REQUEST,
  FETCH_CONFIGURATION_SETUP_SUCCESS,
  FETCH_CONFIGURATION_SETUP_FAILURE,
  FETCH_CONFIGURATION_SETUP_REQUEST,
  SAVE_CONFIGURATION_SETUP_REQUEST,
  SAVE_CONFIGURATION_SETUP_SUCCESS,
  SAVE_CONFIGURATION_SETUP_FAILURE,
} from "./actionTypes";
import {
  fetchLoginDetailsSuccess,
  fetchLoginDetailsFailure,
  fetchUnregisteredEmployeesSuccess, 
  fetchUnregisteredEmployeesFailure,
  resetPasswordSuccess, 
  resetPasswordFailure,
  toggleUserStatusSuccess,
  toggleUserStatusFailure,
  changePasswordSuccess,
  changePasswordFailure
} from "./actions";
import { get, post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Login Details
function* fetchLoginDetailsSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_LOGIN_DETAILS, formData);
    yield put(fetchLoginDetailsSuccess(response));    
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchLoginDetailsFailure(error.message));
  }
}

// Fetch Unregistered Employee List
function* fetchUnregisteredEmployeesSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_UNREGISTERED_EMPLOYEES, formData); 
    yield put(fetchUnregisteredEmployeesSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchUnregisteredEmployeesFailure(error.message));
  }
}

// Worker Saga for Creating a Login User
function* createLoginUserSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CREATE_LOGIN_USER, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to create login user!");
    }

    yield put({ type: CREATE_LOGIN_USER_SUCCESS, payload: response });

    // Success alert
    Swal.fire({
      title: 'Success',
      text: response?.message,
      icon: 'success',
      confirmButtonText: 'OK'
    });
    
  } catch (error) {
    yield put({
      type: CREATE_LOGIN_USER_FAILURE,
      payload: error.response?.data || "Something went wrong!",
    });

    // Error alert
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
}

// Reset Password Saga
function* resetPasswordSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_USER_RESET_PASSWORD, action.payload); 

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to reset password!");
    }

    yield put(resetPasswordSuccess(response.message));

    // Success alert
    Swal.fire({
      title: 'Success',
      text: response?.message,
      icon: 'success',
      confirmButtonText: 'OK'
    });
    
  } catch (error) {
    yield put(resetPasswordFailure(error.message || 'Failed to reset password'));

    // Error alert
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
}

// Toggle User Status Saga
function* toggleUserStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_USER_CHANGE_STATUS, action.payload); 

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to update user status!");
    }

    yield put(toggleUserStatusSuccess(response));

    // Success alert
    Swal.fire({
      title: 'Success',
      text: response?.message,
      icon: 'success',
      confirmButtonText: 'OK'
    });
    
  } catch (error) {
    yield put(toggleUserStatusFailure(error.message || 'Failed to update status!'));

    // Error alert
    Swal.fire({
      title: 'Error',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }
}

function* changePasswordSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_PASSWORD, action.payload); 
    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Password changed successfully.",
      });
      yield put(changePasswordSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to change password.",
      });
      yield put(changePasswordFailure(response));
    }
  } catch (error) {
    console.error("Saga API Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the password",
    });
    yield put(changePasswordFailure(error.message || "Something went wrong."));
  }
}

function* fetchRolesSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);

    const response = yield call(
      post,
      process.env.REACT_APP_GET_ROLES_LIST,
      formData
    );
    yield put({ type: FETCH_ROLES_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error (getRolesList):", error);
    yield put({ type: FETCH_ROLES_FAILURE, payload: error.message });
  }
}

function* fetchAccessRightsSaga({ payload: { roleId } }) {
  try {
    const formData = new FormData();
    formData.append("role_id", roleId);

    const response = yield call(
      post,
      process.env.REACT_APP_GET_ROLE_ACCESS_RIGHTS,
      formData
    );
    yield put({ type: FETCH_ACCESS_RIGHTS_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error (getRoleAccessrights):", error);
    yield put({ type: FETCH_ACCESS_RIGHTS_FAILURE, payload: error.message });
  }
}

function* saveRoleAccessRightsSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_ROLE_ACCESS_RIGHTS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save role access rights!');
    }

    yield put({ type: SAVE_ROLE_ACCESS_RIGHTS_SUCCESS, payload: response });

    Swal.fire({
      icon: 'success',
      title: 'Access Rights Saved',
      text: 'Access rights have been successfully saved.',
      confirmButtonColor: '#7c3aed',
    });
  } catch (error) {
    yield put({ type: SAVE_ROLE_ACCESS_RIGHTS_FAILURE, payload: error });

    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving access rights!',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: '#7c3aed',
    });
  }
}

function* fetchModulesSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);

    const response = yield call(
      post,
      process.env.REACT_APP_GET_MODULES_LIST, 
      formData
    );

    yield put({ type: FETCH_MODULES_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error (fetchModules):", error);
    yield put({ type: FETCH_MODULES_FAILURE, payload: error.message });
  }
}

function* saveModuleSaga(action) {
  try {

    const response = yield call(post,process.env.REACT_APP_SAVE_MODULE_DETAILS,action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save module!");
    }

    yield put({ type: SAVE_MODULE_SUCCESS, payload: response });
    Swal.fire("Success", "Module saved successfully!", "success");
  } catch (error) {
    console.error("Save Module Saga Error:", error);
    yield put({ type: SAVE_MODULE_FAILURE, payload: error.message });
    Swal.fire("Error", error.message || "Something went wrong!", "error");
  }
}

function* deleteModuleSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_DELETE_MODULE,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to delete module!");
    }

    yield put({ type: DELETE_MODULE_SUCCESS, payload: response });
    Swal.fire("Deleted!", "Module deleted successfully!", "success");
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while deleting!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: DELETE_MODULE_FAILURE, payload: error.message });
  }
}

function* fetchConfigurationSetupSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);

    const response = yield call(
      post,
      process.env.REACT_APP_GET_CONFIGURATION_SETUP,
      formData
    );

    yield put({ type: FETCH_CONFIGURATION_SETUP_SUCCESS, payload: response });
  } catch (error) {
    console.error("Saga API Error (fetchConfigurationSetup):", error);
    yield put({ type: FETCH_CONFIGURATION_SETUP_FAILURE, payload: error.message });
  }
}

// 🔹 Save Configuration Setup
function* saveConfigurationSetupSaga(action) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_SAVE_CONFIGURATION_SETUP,
      action.payload
    );

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save configuration setup!");
    }

    yield put({ type: SAVE_CONFIGURATION_SETUP_SUCCESS, payload: response });
    Swal.fire("Success", "Configuration setup saved successfully!", "success");
  } catch (error) {
    console.error("Save Configuration Setup Saga Error:", error);
    yield put({ type: SAVE_CONFIGURATION_SETUP_FAILURE, payload: error.message });
    Swal.fire("Error", error.message || "Something went wrong!", "error");
  }
}

// Watcher Saga
function* loginCreationSaga() {
  yield takeEvery(FETCH_LOGIN_DETAILS, fetchLoginDetailsSaga);
  yield takeLatest(FETCH_UNREGISTERED_EMPLOYEES, fetchUnregisteredEmployeesSaga);
  yield takeLatest(CREATE_LOGIN_USER_REQUEST, createLoginUserSaga);
  yield takeLatest(RESET_PASSWORD_REQUEST, resetPasswordSaga);
  yield takeLatest(TOGGLE_USER_STATUS_REQUEST, toggleUserStatusSaga);
  yield takeLatest(CHANGE_PASSWORD_REQUEST, changePasswordSaga);
  yield takeLatest(FETCH_ROLES_REQUEST, fetchRolesSaga);
  yield takeLatest(FETCH_ACCESS_RIGHTS_REQUEST, fetchAccessRightsSaga);
  yield takeLatest(SAVE_ROLE_ACCESS_RIGHTS_REQUEST, saveRoleAccessRightsSaga);
  yield takeLatest(FETCH_MODULES_REQUEST, fetchModulesSaga);
  yield takeLatest(SAVE_MODULE_REQUEST, saveModuleSaga);
  yield takeLatest(DELETE_MODULE_REQUEST, deleteModuleSaga);
  yield takeLatest(FETCH_CONFIGURATION_SETUP_REQUEST, fetchConfigurationSetupSaga);
  yield takeLatest(SAVE_CONFIGURATION_SETUP_REQUEST, saveConfigurationSetupSaga);
}

export default loginCreationSaga;
